var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 0.5C4.21168 0.5 4.35476 0.559263 4.46025 0.664752C4.56574 0.770242 4.625 0.913316 4.625 1.0625V2.75H11.375V1.0625C11.375 0.913316 11.4343 0.770242 11.5398 0.664752C11.6452 0.559263 11.7883 0.5 11.9375 0.5C12.0867 0.5 12.2298 0.559263 12.3352 0.664752C12.4407 0.770242 12.5 0.913316 12.5 1.0625V2.75H14.5625C15.287 2.75 15.875 3.338 15.875 4.0625V16.0625C15.875 16.4106 15.7367 16.7444 15.4906 16.9906C15.2444 17.2367 14.9106 17.375 14.5625 17.375H1.4375C1.0894 17.375 0.755564 17.2367 0.509422 16.9906C0.263281 16.7444 0.125 16.4106 0.125 16.0625V4.0625C0.125 3.338 0.713 2.75 1.4375 2.75H3.5V1.0625C3.5 0.913316 3.55926 0.770242 3.66475 0.664752C3.77024 0.559263 3.91332 0.5 4.0625 0.5ZM14.75 7.625H1.25V16.0625C1.25 16.166 1.334 16.25 1.4375 16.25H14.5625C14.6122 16.25 14.6599 16.2302 14.6951 16.1951C14.7302 16.1599 14.75 16.1122 14.75 16.0625V7.625ZM1.4375 3.875C1.38777 3.875 1.34008 3.89475 1.30492 3.92992C1.26975 3.96508 1.25 4.01277 1.25 4.0625V6.5H14.75V4.0625C14.75 4.01277 14.7302 3.96508 14.6951 3.92992C14.6599 3.89475 14.6122 3.875 14.5625 3.875H1.4375Z",
    fill: "#767C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.f43e1106c13d07ca9c4c16686d906507.svg";
export { ForwardRef as ReactComponent };